import whiteLabelService from "@http/services/white-label.service";
import { useQuery } from "@tanstack/react-query";

export const whiteLabelQueryKey = ["whiteLabel"] as const;

export function useWhiteLabel() {
  return useQuery({
    queryKey: whiteLabelQueryKey,
    queryFn: () => whiteLabelService.get(),
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}
